<!-- 实时视频组件 -->
<template>
  <div ref="box" @mouseover="showTool = true" @mouseout="showTool = false" class="video-box">
    <!-- 视频播放源 -->
    <video
      id="mvcpVideo"
      ref="video"
      @timeupdate="timeupdate"
      :poster="require('@/icon/real-video/video-loding.gif')"
      autoplay
      preload="auto"
      :muted="muted"
    ></video>
    <audio ref="audio" id="mvcpAudio"></audio>
    <div id="mvcpAudio1"></div>
    <!-- 顶部控制栏 -->
    <div v-show="showTool" class="monitor_topbar">
      <div class="topbar_left">
        <span v-if="device" class="left userName">{{ device.serialNumber }}</span>
        <img
          class="net_type"
          title="wifi"
          v-if="helmetStatus && helmetStatus.WIFI !== '0'"
          src="@/icon/real-video/wifi.png"
        />
        <img class="net_type" title="4g" v-else src="@/icon/real-video/4g.png" />
      </div>
      <div class="topbar_right">
        <div class="left definit">
          <div class="resolution-video" @click="showList">
            {{ currentDefinit }}
          </div>
          <div class="resolut-list" v-if="definitShow">
            <ul>
              <li v-for="item in resolutionPs" :key="item.value" @click="switchResolutionP(item)">
                {{ item.label }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!-- 底部控制栏 -->
    <div v-show="showTool" class="video_controller">
      <img v-if="isVideoPlay" class="video_pause" src="@/icon/real-video/video-pause.png" @click="switchVideoPlay" />
      <img v-else class="video_pause" src="@/icon/real-video/video-play.png" @click="switchVideoPlay" />
      <div class="progress_time">
        <progress value="100" max="100" class="video_progress"></progress>
        <span class="video_time">{{ playedTime }}</span>
      </div>
      <img v-if="muted === true" class="video_volume" src="@/icon/real-video/volume-off.png" @click="switchMuted" />
      <img v-else class="video_volume" src="@/icon/real-video/volume-up.png" @click="switchMuted" />
      <img class="video_plat"  v-if="!showPlay" @click="VideomuteMic" src="@/icon/real-video/microphone.png"/>
      <img class="video_plat" v-if="showPlay" @click="handleunmuteMic" src="@/icon/real-video/microphone-off.png" />
      <img class="full_btn" src="@/icon/real-video/fullscreen.png" @click="switchFullScreen" />
    </div>
  </div>
</template>

<script>
import {
  helmetJoinMeet,
  helmetExitMeet,
  changeResolutionP,
  setHandleHelmetLeave,
  setHandleHelmetOperationResponse,
  handleHelmetOperationResponse,
  muteMic,
  unmuteMic,
  leaveRoomSelf,
  _getUserSig,
  localMuteMic,
  localUnmuteMic
} from '@/common/websocket/trtc-main'
import { operations } from '@/api/log/operation'
import { setUserHelmetLeave, CHAT } from '@/common/websocket/index'
import { getSession, delSession,PrefixInteger } from '@/api/common'
import { ACTION, initSwitch } from '@/common/websocket/remoteControl'
export default {
  name: 'RealVideoCompnent',
  props: {
    helmetId: {
      type: String,
      default: '',
    },
    userId: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      device: {
        serialNumber: null,
        userId: '',
        userName: '',
      },
      resolutionP: 12,
      // 是否允许出现上下控制栏
      allowClick: false,
      resolutionPs: [
        { label: this.$t('fluent'), value: 10 },
        { label: this.$t('standardDefinition'), value: 12 },
        { label: this.$t('highDefinition'), value: 14 },
      ],
      playedTime: '00:00:00',
      // 展示工具栏
      showTool: false,
      // 展示的播放状态，不代表视频真的在播放，video.paused可以获取真实的状态
      isVideoPlay: true,
      muted: true,
      isFullScreen: false,
      ACTION,
      currentDefinit:  this.$t('standardDefinition'),
      // 是否显示清晰度列表
      definitShow: false,
      /**
       * 用于，点击左侧用户直接关闭视频切换另一个用户，重新等于传值 device
       * 如果传 {serialNumber： null， username：null}，使用前一个数据
       */
      newDevice: [],
      // 用于 记录视频关闭操作，{userId: '',userName: ''}
      userData: [],
      isCloudRoom: this.$store.getters.rtcType,
      isHasMedia: null,
      // 是否显示本地静音图标
      showPlay: true,
    }
  },
  mounted() {
    _getUserSig()
    if (!this.helmetId || !this.userId) {
      return
    }
    this.device = {
      serialNumber: this.helmetId,
      userId: this.userId,
      userName: this.userName,
    }
    this.$nextTick(() => {
      this.linkHelmet()
    })
  },
  computed: {
    helmetStatus() {
      this.userData = {
        userId: this.device.userId,
        userName: this.device.userName,
        serialNumber: this.device.serialNumber,
      }
      // 判断当前设备号，用于关闭视频窗口，记录历史记录
      this.newDevice = this.device.serialNumber === null ? this.newDevice : this.device
      return this.$store.state.helmetStatusObj[this.device.serialNumber]
    },
    handleresolutionP() {
      return this.$store.state.handleresolutionP
    },
  },
  methods: {
    // 点击本地静音
    VideomuteMic() {
      localMuteMic()
      this.showPlay = true
    },
    // 点击本地取消静音
    handleunmuteMic() {
      localUnmuteMic()
      this.showPlay = false
    },
    getQueryVariable(name) {
      try {
        var url = window.location.href
        if (url.indexOf('?') === -1) {
          return ''
        }
        var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
        var r = url.split('?')[1].match(reg)
        if (r != null) {
          return r[2]
        }
        // 如果此处只写return,则返回的是undefined //NOSONAR
        return ''
      } catch (e) {
        // 如果此处只写return,则返回的是undefined //NOSONAR
        return ''
      }
    },
    // 播放视频
    playVideo() {
      setTimeout(() => {
        let userId = this.device.userId
        let username = this.device.userName
        // 加入视频会议
        helmetJoinMeet(this.device.serialNumber, 12, userId, username)
        this.$store.commit('openVedio', true)
        initSwitch(this.device.serialNumber)
        let param = [
          {
            childOperation: 51,
            event: -1,
            logTimestamp: new Date().format('yyyy-MM-dd hh:mm:ss'),
            loginUserName: getSession('username'),
            operation: '实时视频',
            remoteHelmetId: this.device.serialNumber,
            remoteUserId: userId,
            remoteUserName: username,
          },
        ]
        // 上传操作日志
        operations(param)
      }, 1000)
    },
    // 关闭窗口
    close() {
      // 实时视频全屏处理
      if (this.isFullScreen) {
        this.switchFullScreen()
      }
      this.isVideoPlay = true
      setHandleHelmetOperationResponse(() => {})
      setUserHelmetLeave(() => {})
      //   this.$emit('update:device', {})

      helmetExitMeet(this.device.serialNumber)
      // 退出后清空消息响应处理

      setHandleHelmetLeave(() => {})
      let mediaTag = this.$refs.video.srcObject
      this.isHasMedia = mediaTag

      this.$refs.video.srcObject = null
      this.currentDefinit =  this.$t('standardDefinition')
      if (this.isHasMedia !== null) {
        // 离开房间
        let userId = null
        let username = null
        userId = this.userData.userId
        username = this.userData.userName
        let param = [
          {
            childOperation: 51,
            event: 0,
            logTimestamp: new Date().format('yyyy-MM-dd hh:mm:ss'),
            loginUserName: getSession('username'),
            operation: '实时视频',
            remoteHelmetId: this.newDevice.serialNumber,
            remoteUserId: userId,
            remoteUserName: username,
          },
        ]
        this.$store.commit('openVedio', false)
        operations(param)
        leaveRoomSelf()
      }
    },
    // 切换全屏状态
    switchFullScreen() {
      this.isFullScreen = !this.isFullScreen
      if (this.isFullScreen) {
        // 全屏
        if (document.documentElement.webkitRequestFullScreen) {
          this.$refs.box.webkitRequestFullScreen()
        } else if (document.documentElement.mozRequestFullScreen) {
          this.$refs.box.mozRequestFullScreen()
        } else if (document.documentElement.msRequestFullScreen) {
          this.$refs.box.msRequestFullScreen()
        }
      } else {
        // 退出全屏
        if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen()
        }
      }
    },
    // 切换视频播放状态
    switchVideoPlay() {
      this.isVideoPlay = !this.isVideoPlay
      if (this.isVideoPlay) {
        // 播放中
        this.$refs.video.play()
        localUnmuteMic()
      } else {
        this.$refs.video.pause()
        localMuteMic()
      }
      this.switchMuted()
    },
    // 切换静音状态
    switchMuted() {
      this.muted = !this.muted
      if (this.muted) {
        muteMic()
      } else {
        unmuteMic()
      }
    },
    // 视频播放时间更新
    timeupdate() {
      if (this.$refs.video) {
        let time = this.$refs.video.currentTime
        var hour = Math.floor(time / 3600)
        var minute = Math.floor((time % 3600) / 60)
        var second = Math.floor(time % 60)
        this.playedTime = PrefixInteger(hour, 2) + ':' + PrefixInteger(minute, 2) + ':' + PrefixInteger(second, 2)
      }
    },
    // 点击显示的清晰度=》显示下拉的清晰度列表
    showList() {
      this.definitShow = true
    },
    // 切换分辨率
    switchResolutionP(resolutionP) {
      this.definitShow = false
      this.currentDefinit = resolutionP.label
      changeResolutionP(this.device.serialNumber, resolutionP.value)
    },
    linkHelmet() {
      if (this.device.serialNumber) {
        // 播放新实时视频时 自定义消息响应处理
        setHandleHelmetOperationResponse(handleHelmetOperationResponse)
        setHandleHelmetLeave(this.close)
        setUserHelmetLeave(this.close)
        // 默认静音
        this.muted = true
        this.playVideo()
      }
    },
    layout() {
      delSession('access_token')
      delSession('expireTime')
      delSession('HWSecurity_access_token')
      delSession('userId')
      sessionStorage.removeItem('featureCode')
      sessionStorage.removeItem('isAdmin')
      window.CHAT.socket.close()
      CHAT.wsclose()
      console.log('退出成功')
      this.$store.commit('showTip', false)
    },
  },
  watch: {
    muted(val) {
      console.log('muted', val)
      if (!val) {
        this.$store.commit('handleIsTrtcMuted', false)
      } else {
        this.$store.commit('handleIsTrtcMuted', true)
      }
    },
    handleresolutionP(val) {
      if (val === 10) {
        this.currentDefinit = this.$t('fluent')
      } else if (val === 12) {
        this.currentDefinit =  this.$t('standardDefinition')
      } else {
        this.currentDefinit = this.$t('highDefinition')
      }
    },
  },
  beforeDestroy() {
    // 销毁资源
    this.close()
    this.layout()
  },
}
</script>

<style scoped>
.video-box {
  position: relative;
  height: 100%;
  background-color: #fff;
}

.video_controller {
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 33px !important;
  line-height: 33px;
  z-index: 1000;
  color: #fff;
  letter-spacing: 1px;
}
.video_controller .video_pause {
  width: 23px;
  height: 23px;
  float: left;
  left: 10px;
  top: 5px;
  position: absolute;
  cursor: pointer;
}

.video_controller .progress_time {
  height: 3px;
  width: 74%;
  position: absolute;
  left: 46px;
  top: 0;
}

.video_controller .video_progress {
  height: 3px;
  width: calc(100% - 60px); /* no */
  float: right;
  margin-top: 15px;
}

.video_controller .video_time {
  font-size: 12px;
  color: white;
  width: 60px; /* no */
  margin-top: 0px;
  float: left;
}

.video_controller .video_volume {
  cursor: pointer;
  width: 23px;
  height: 23px;
  position: absolute;
  right: 38px;
  top: 5px;
}
.video_plat {
  cursor: pointer;
  position: absolute;
  right: 70px;
  top: 5px;
  width: 23px;
  height: 23px;
}

.video_controller .full_btn {
  width: 30px;
  height: 30px;
  position: absolute;
  right: 5px;
  top: 3px;
  cursor: pointer;
  bottom: 26px;
}
video {
  object-fit: fill;
  width: 100%;
  height: 100%;
}

.monitor_topbar {
  opacity: 1;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 32px;
  z-index: 1000;
  color: #fff;
  letter-spacing: 1px;
}

.monitor_topbar:hover {
  opacity: 1;
}
.topbar_left {
  float: left;
  padding: 0 10px;
  line-height: 32px;
}

.topbar_left .net_type {
  width: 17px;
  height: 17px;
  padding-top: 6px;
  padding-left: 4px;
}

.topbar_right {
  float: right;
  padding: 0px 10px;
}
.topbar_right .resolut-list {
  position: absolute;
  top: 32px;
  left: 50%;
  transform: translate(-50%, 0);
}

.topbar_right .resolut-list ul {
  width: 38px; /* no */
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  text-align: center;
}

.topbar_right .resolut-list ul li {
  width: 100%;
  line-height: 26px; /* no */
}
.topbar_right .definit {
  position: relative;
  margin-right: 10px;
}

.topbar_right .definit .resolution-video {
  float: left;
  margin-right: 5px;
  cursor: pointer;
  color: #fff;
  line-height: 32px;
}

.topbar_right .definit .close {
  width: 17px;
  height: 17px;
  margin-top: 8px;
  cursor: pointer;
}
</style>
